// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__15ODf","title":"AfterBackImages_title__mtsAx","images":"AfterBackImages_images__gWVBL"};